import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { DonateProvider } from "@/context/DonateContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DonationDialog from "@/components/DonationDialog";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Legacy from "@/pages/Legacy";
import Ethiopia from "@/pages/Ethiopia";
import Board from "@/pages/Board";
import Contact from "@/pages/Contact";
import Gala from "@/pages/Gala";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <DonationDialog />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DonateProvider>
          <SmoothScroll />
          <ScrollToTop />
          <Toaster theme="dark" position="top-center" richColors closeButton
            toastOptions={{ style: { background: "#1A1C1A", border: "1px solid rgba(200,165,91,0.3)", color: "#FDFBF7" } }} />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/legacy" element={<PublicLayout><Legacy /></PublicLayout>} />
            <Route path="/ethiopia" element={<PublicLayout><Ethiopia /></PublicLayout>} />
            <Route path="/board" element={<PublicLayout><Board /></PublicLayout>} />
            <Route path="/gala" element={<PublicLayout><Gala /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
            <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </DonateProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
